import React from 'react';
import { Check, User, Package, CreditCard, FileText, PenTool, Users, Send, Euro } from 'lucide-react';
import { cn } from '@/lib/utils';

const stepIcons = {
  role: Users,
  customer: User,
  product: Package,
  payment: CreditCard,
  terms: FileText,
  signature: PenTool,
  sendToCustomer: Send,
  reservation: Euro
};

export const ProgressSteps = ({ steps, activeSteps, currentStep, completedSteps, t }) => {
  return (
    <div className="w-full py-6 overflow-x-auto">
      <div className="flex items-center justify-between relative min-w-max px-2">
        {/* Progress line background */}
        <div className="absolute top-5 left-4 right-4 h-0.5 bg-border" />
        
        {/* Active progress line */}
        <div 
          className="absolute top-5 left-4 h-0.5 bg-primary transition-all duration-500"
          style={{ 
            width: `${(currentStep / (activeSteps.length - 1)) * (100 - (8 / activeSteps.length))}%` 
          }}
        />
        
        {activeSteps.map((key, index) => {
          const Icon = stepIcons[key];
          const isCompleted = completedSteps.includes(key);
          const isCurrent = index === currentStep;
          const isPast = index < currentStep;
          
          return (
            <div 
              key={key} 
              className="flex flex-col items-center relative z-10 flex-1 min-w-[80px]"
            >
              <div 
                className={cn(
                  "w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 shrink-0",
                  isCompleted || isPast
                    ? "bg-success text-success-foreground"
                    : isCurrent
                    ? "bg-primary text-primary-foreground shadow-glow animate-pulse-glow"
                    : "bg-muted text-muted-foreground"
                )}
              >
                {isCompleted || isPast ? (
                  <Check className="w-5 h-5" />
                ) : (
                  <Icon className="w-5 h-5" />
                )}
              </div>
              <span 
                className={cn(
                  "mt-2 text-[10px] sm:text-xs font-medium text-center w-full px-1 leading-tight transition-colors duration-300",
                  isCurrent 
                    ? "text-primary" 
                    : isCompleted || isPast
                    ? "text-success"
                    : "text-muted-foreground"
                )}
              >
                {steps[key]}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressSteps;
